<section
  [id]="wrapperSectionKey"
  class="w-full relative {{ elementKeyRoot }} {{ elementKey }}-font"
  [class.select-none]="isInEditor"
  blazeElementSelectionHelper
  [ngStyle]="containerStyles"
  [class.editable]="canBeLiveEdited"
  [isInEditor]="isInEditor"
  (click)="onAreaClicked($event)"
  (clickOutside)="toggleLiveEdit(false)"
  [clickOutsideEnabled]="isLiveEdit()"
>
  <div [ngStyle]="contentWrapperStyles" class="element-wrapper">
    <div
      class="element-content {{ elementKeyRoot }} {{ elementKey }}"
      [style.visibility]="isLiveEdit() ? 'hidden' : 'visible'"
      [tabIndex]="0"
      [ngStyle]="textStyles"
      [innerHTML]="value | securityTrust: 'html'"
      (click)="onAreaClicked($event)"
    ></div>
    @if (isLiveEdit() || isEditorLoaded()) {
      <editor
        #editor
        [init]="editorConfig"
        [id]="editorKey"
        [initialValue]="value"
        class="{{ isLiveEdit() ? 'visible' : 'invisible pointer-events-none' }}"
        [class.validation-error]="hasValidationError"
        [style.padding]="editorPadding"
        [style.alignItems]="editorAlign"
        (onChange)="onValueChanged($event)"
        (mousedown)="onEditorMousedown($event)"
      />
    }
  </div>
</section>
